<mat-table
	[dataSource]="stateService.dataSource()"
	class="contentTable"
	[trackBy]="TrackByMethods.trackById"
	[class.loadingData]="stateService.isLoading()"
	multiTemplateDataRows
>
	<!-- Checkbox Column -->
	@if (isSelectionEnabled()) {
		<ng-container matColumnDef="select">
			<mat-header-cell mat-header-cell class="textAlignCenter specialCell" *matHeaderCellDef>
				<mat-checkbox
					(change)="$event ? stateService.toggleAllSelection() : null"
					[checked]="stateService.isAllSelected()"
					[indeterminate]="stateService.isSomeSelected() && !stateService.isAllSelected()"
				/>
			</mat-header-cell>
			<mat-cell class="textAlignCenter specialCell" mat-cell *appMatCellDef="let element; dataSource: stateService.dataSource()">
				<mat-checkbox
					appStopPropagation
					(change)="$event ? stateService.toggleSelection(element) : null"
					[checked]="stateService.isSelected(element)"
				/>
			</mat-cell>
		</ng-container>
	}

	<ng-content select="[tableColumns]" />

	<!-- Actions Column -->
	<ng-container matColumnDef="actions">
		<mat-header-cell mat-header-cell *matHeaderCellDef />
		<mat-cell mat-cell *matCellDef="let element">
			<div class="actionsWrapper" appStopPropagation>
				<ng-container *ngTemplateOutlet="actionTemplate(); context: {$implicit: element}" />

				@if (isExpandable()) {
					<button (click)="toggleExpandElement(element)" color="accent" mat-icon-button>
						<sim-animated-material-icon
							[trigger]="stateService.isElementExpanded(element.id)"
							[startIcon]="expandStartIcon"
							[endIcon]="expandEndIcon"
						/>
					</button>
				}
			</div>
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true" />
	<mat-row
		mat-row
		*matRowDef="let element; columns: displayedColumns()"
		class="example-element-row"
		[class.hasExpandedElement]="isExpandable()"
		mat-ripple
		[class.example-expanded-row]="stateService.isElementExpanded(element.id)"
		(click)="toggleExpandElement(element)"
	/>
	<mat-row mat-row *matRowDef="let row; columns: isExpandable() ? ['expandedDetail'] : []" class="example-detail-row" />
</mat-table>
